import React from 'react';
import { SectionHeading } from '../SectionHeading';
const breakthroughs = ['A system that purifies your pool water \u2014 with zero chemicals.', 'A patented technology that balances pH to 7.2\u20137.6 naturally, while killing algae and bacteria.', 'Engineered end to end for a healthy, safe swimming experience.'];
export function Breakthroughs() {
  return <section className="border-t border-ink-950/8 bg-paper py-20 lg:py-28" data-id="element-88" data-mp="tpfj1qnc6pfn">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-89" data-mp="ymegai2arci2">
        <SectionHeading eyebrow="Three breakthroughs" title="Three breakthroughs. One device." lede={'These aren\u2019t three separate products. They converge into a single unit on your equipment pad \u2014 and it\u2019s called Fusion 44X.'} data-id="element-90" data-mp="13kzeyd1who4e" />

        <ol className="mt-12 grid gap-px overflow-hidden rounded-2xl bg-ink-950/10 sm:grid-cols-3" data-id="element-91" data-mp="39f8uo6n62ntu">
          {breakthroughs.map((item, index) => <li key={item} className="flex flex-col bg-paper p-7 sm:p-8" data-id="element-92" data-mp="3ee2ai5pxeqx6" data-mpi={index}>
              <span className="font-display text-sm font-semibold text-aqua-600" data-id="element-93" data-mp="2yunrf7q5mgae">
                {String(index + 1).padStart(2, '0')}
              </span>
              <p className="mt-5 font-display text-xl font-medium leading-snug tracking-tight text-ink-950" data-id="element-94" data-mp="2q1at1q9bmmgx">
                {item}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}